import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { getRandomInt, randomString, getCDate, check, sleep, genKey } from '@/customFunction';
const headers = {'Accept': 'application/json'};
import router from '../router'
import {
  firebase,
  auth
} from '@/fb'

Vue.use(Vuex);


export default new Vuex.Store({
  state: {
    site: {
      "avatar": "https://firebasestorage.googleapis.com/v0/b/cip-generic.appspot.com/o/default-user.png?alt=media&token=82389d15-0419-4d2c-8b5e-5fe3e18c3ca7",
      "language": "en",
      "logo": "/FullColorHor.png",
      "wlogo": "/weblogo.png",
      "name": "Evotik - SaaS",
      "theme": {
        "light": {
          "accent": "#023d66",
          "error": "#FF5252",
          "info": "#2196F3",
          "primary": "#023d66",
          "secondary": "#1176bc",
          "success": "#4CAF50",
          "warning": "#FFC107"
        }
      }
    },
    i18n: {
      en: {
        grand_category: "Grand category",
        grandCategories: "Grand categories",
        deleteBtn: "Yes, delete",
        areYouSureOfDelete: "Are you sure of delete |item|",
        categories: "Categories",
        cbls_no: "Cbls no",
        business_name_english: "Business name",
        is_branch: "Is branch",
        est_date: "Established date",
        expiry_date: "Expiry date",
        economic_department: "Economic department",
        mobile_no: "Mobile",
        phone_no: "Phone",
        email: "Email",
        edit:'Edit',
        actions:'Actions',
        events:'Events',
        platforms:'Platforms',
        megatracker:'Tracker',
        "tracker-domains": `Domains`,
        "tracker-pixels": `Pixels`,
        trackers: `Trackers`,
        domains: `Domains`,
        pixels: `Pixels`,
        trackers: `Trackers`,
        pixel: `Pixel`,
        platform: `Platform`,
        selector: `Selector`,
        domain: `Domain`,
        action: `Action`,
        event: `Event`,
        trackerdomains:`Domains`,
        trackerPixels:`Pixels`,
        trakers:`Trackers`,
        snapp: `CTA Hype`,
        price: `Price`,
        duration: `Duration (days)`,
        active: `Active`,
        public: `Public`,
        label: `Label`,
        plans: `Plans`,
        manage_plans: `Manage Plans Details`,
        services: `Services`,
        manage_services: `Manage Services Details`,
        title: `Title`,
        sub_title: `Sub title`,
        body: `Body`,
        button_text: `Button Text`,
        button_target: `Button Target`,
        email_label: `Email Field Label`,
        phone_label: `Phone Field Label`,
        name_label: `Name Field Label`,
        link_text: `Link Text`,
        link_url: `Link URL`,
        image_url: `Image URL`,
        youtube_url: `YouTube URL`,
        vimeo_url: `Vimoe URL`,
        email_validation: `Validate Email`,
        name_validation: `Validate Name`,
        phone_validation: `Validate Phone`,
        position: `CTA Position`,
        outer_padding: `Padding`,
        button_size: `Button Size`,
        field_type: `Field Style`,
        right_to_left: `Right to Left Direction`,
        background_color: `Background Color`,
        text_color: `Text color`,
        link_color: `Link Color`,
        field_color: `Field Color`,
        field_text_color: `Field Text Color`,
        label_color: `Label Color`,
        button_color: `Button Color`,
        button_text_color: `Button Text Color`,
        website:`Website`,
        logo:`Logo`,
        leads:`Leads`,
        all_invoices_and_billing:`Plan and Billing`,
        see_current_plan_and_invoices:`Manage your plans and billing`,
        application:`Application`,
        brands:`Brands`,
        brand:`Brand`,
        ctas:`Calls to Action`,
        links:`Links`,
        upgrade:`Upgrade`,
        available_services:`Available Services`,
        address:`Address`,
        tax_id:`Tax ID`,
        country:`Country`,
        company:`Company`,
        billing:`Billing`,
        support:`Support Center`,
        knowledge:`Knowledge Base`,
        update_success:`Updated Successfully`,
        regenerate_api_token:`Regenerate API token`,
        change_password:`Change Password`,
        here_you_can_request_password_change:`Here you can submit a request to reset your password`,
        submit_request_to_change_password:`submit request to recieve link by email`,
        account_settings:`Account Settings`,
        here_you_can_edit_account_settings:`Here you can edit your business account settings`,
        email_notifications:`Recieve notifications by email`,
        update_account:`Update Account Settings`,
        user_settings:`User Settings`,
        here_you_can_edit_user_settings:`Here you can edit your personal user settings`,
        update_user:`Update User Settings`,
        affliliate_code:`Affiliate Code`,
        copy_affliliate_code:`Copy Affiliate Code`,
        re_password:`Retype Password`,
        reset_email_sent:`Reset email is sent`,
        password_no_match:`Passwords do not match`,
        phone_required:`Phone is required`,
        acceptTOC:`I Accept Terms and Conditions`,
        /////////////////// BAYAA
        dashboard:`Dashboard`,
        result:`Result`,
        close_menu:`close menu`,
        its:`SaaS Made For You`,
        intro_subtitle:`Tools For Your Business`,
        no_notifications:`No Notifications`,
        features_title: `Features as Benefits:`,
        benefit_one: `Benefit 1`,
        benefit_two: `Benefit 2`,
        benefit_three: `Benefit 3`,
        benefit_four: `Benefit 4`,
        features_footer: `...there is a lot more to find`,
        footer_intro: `The latest technologies and artificial intelligence to achieve fully customized results for individuals and organizations to help them discover new ways of thinking and doing things.`,
        copyright_reserved: `All rights reserved for`,
        contact_us_through_email: `Contact us through Email:`,
        toc:`Terms & Conditions`,
        instructions_title: `Assessment Instructions`,
        instructions_subtitle: `Please check the following instructions thoroughly`,
        time_is_open: `There is no time limit to this assessment`,
        assessment_instruction_intro: `Questions are answered by choosing one of the following answers:`,
        to_almost_no_extent: `To almost no extent`,
        to_a_slight_extent: `To a slight extent`,
        to_a_moderate_extent: `To a moderate extent`,
        to_great_extent: `To a great extent`,
        to_very_great_extent: `To a very great extent`,
        assessment_done_check_result: `Assessment is done you can check the result`,
        agree_to_instructions: `I have read the instructions and ready to start assessment`,
        start_assessment: `Start Assessment`,
        assessment_result: `Assessment Result`,
        all_users: `All users`,
        manage_platform_users: `Manage platform users`,
        businesses: `Institutions`,
        users_count: `Users number`,
        users_started: `Started assessment`,
        users_finished: `Finished assessment`,
        user_users: `free seat(s) left`,
        left_tokens: `You have`,
        add_user: `Invite Team Members`,
        business:`business`,
        empoyee_name: `Empoyee name`,
        verified_email: `Verified Email`,
        finished_assessment: `Finished assessment`,
        print_pdf: `Print report`,
        update: `Update`,
        assessment_progress: `Assessment progress`,
        building_next_question: `Building next question`,
        next: `Next`,
        end_and_show_results: `Finish & View Result`,
        creativity_problem: 'Creativity & Problem Solving',
        risk_taking: 'Risk Taking',
        com_relation: 'Communication & Relationships',
        excution_managment: 'Execution & Management',
        INVALID_PASSWORD: 'Invalid Password',
        user_not_found: `User Not Found`,
        assessment_result: `Assessment result`,
        assessment_result_map: `Assessment result and innovation map`,
        final_result: `Final result`,
        point: `Point`,
        detailed_report: `Detailed Report Ready For Print`,
        stop_finish_later:`You can stop in the middle of the assessment and come back later to continue where you left`,
        use_pc_or_phone: `You can finish this assessment using your PC or Smart Phone`,
        its_pub_intro:`AI Driven Innovation Maps For Individuals & Institutions`,


        catalog:`Catalog`,
        shipping:`Shipping`,
        tickets:`Support Tickets`,
        wallet:`Wallet`,
        account:`Account`,
        store:`Store`,
        accounts:`Accounts`,
        requests:`Requests`,
        leadsMaster:`All Leads`,
        ///////
        item_name: 'ITEM NAME',
        price: 'price',
        quantity: 'Quantity',
        order_total: 'Order Total',
        your_details: 'Your Details',
        item_total: 'ITEM TOTAL',
        continue_shopping: 'continue shopping',
        submit_order: 'submit order',
        cart: 'Cart',
        order_now: 'order now',
        finish_order: 'finish order',
        time_left: 'Time Left',
        details: 'Details',
        country_choose: 'Please choose your country',
        items_in_order: 'Items in order',
        name: 'Name',
        phone_number: 'Phone Number',
        add_to_cart: 'Add to cart',
        thank_you: 'Your order was submited',
        tomorrow: `Come back tomorrow for our latest offers`,
        deliveryJO: `3 JDs added for Delivery Charges`,
        deliveryJOS: `You earned FREE Delivery for your order`,
        deliverySA: `50 Riyals added for Delivery Charges`,
        deliverySAS: `You earned FREE Delivery for your order`,
        delivery_total:`Delivery Fees`,
        delivery_free: `You earned FREE Delivery for your order`,
        sold: `sold `,
        piece: ` pieces`,
        added_to_cart: `added to cart`,
        size_color:`size/color`,
        cancel:`cancel`,
        total: 'Total',
        lowestJO:`Lowest Prices In Jordan`,
        lowestSA:`Lowest Prices In KSA`,
        dismiss:`Dismiss`,
        search:`Search`,
        back:`Go back`,
        tax:`Tax Included`,
        //// nav
        start:`Start now`,
        emailSoftware:`Emails System`,
        campaigns:`Campaigns`,
        campaign:`Campaign`,
        lists:`Lists`,
        list:`List`,
        templates:`Templates`,
        template:`Template`,
        accountCreated:`Account Created`,
        sent:`Sent`,
        opened:`Opened`,
        clicked:`Clicked`,
        lastChange:`Last Change`,
        agent:`Employee`,
        access:`Access`,
        userRole: `User Role`,
        user: `User`,
        users: `Users`,
        admin: `Admin`,
        superadmin: `Super Admin`,
        userEmail: `User Email`,
        userName: `Username`,
        close: `Close`,
        position: `Position`,
        submitBtn: `Save`,
        reload: `reload`,
        subject: `Subject`,
        fromName: `From Name`,
        fromEmail: `From Email`,
        replyTo: `Reply To`,
        lastUpdated: `Last Updated`,
        sendingActive: `Sending...`,
        inDraft: `Draft`,
        alreadySent: `Sent`,
        sendIconTooltip: `Send Now`,
        scheduleIconTooltip: `Send Later`,
        valid_email: `Please enter a valid Email`,
        leads: `Leads`,
        subscribers: `Subscribers`,
        suppression: `Supression`,
        offices: `Offices`,
        loginWithGoogle: `Login with Google`,
        register: `Register`,
        forgetPassword: `Forget password?`,
        sendResetEmail:`Send Reset Email`,
        please_use_google_to_login: `Please use Google to login`,
        user_not_found: `Account does not exist`,
        listings: `Listings`,
        applicationsCenter: `Applications`,
        cv: `Resume`,
        cvs: `Resumes`,
        resume: `Resume`,
        resumes: `Resumes`,
        coverletters: `Cover Letters`,
        appsettings: `Settings`,
        applications: `Applications`,
        inbox: `Inbox`,
        corporate: `Corporate`,
        billing: `Billing`,
        receipts: `Receipts`,
        plan: `Plan`,
        upgradePlan: `Upgrade`,
        addToShortList: `Add To Shortlist`,
        shortlists: `Shortlists`,
        note: `Note`,
        from: `From`,
        to: `To`,
        latest: `Latest`,
        specialty: `Specialty`,
        city: `City`,
        state: `State`,
        verified: `Verified Email`,
        prefer: `Prefer Email`,
        limit: `Limit`,
        description: `Description`,
        "cover-letters": `Cover Letters`,
        language: `Language`,
        header: `Letter Header`,
        greeting: `Letter Greeting`,
        introduction: `Letter Introduction`,
        body: `Letter Body`,
        closing: `Letter Closing`,
        signature: `Letter Signature`,





          /////////////
            captcha:`Please enter the code in the picture above`,
            wrong_captcha: `You have entered a wrong code`,
            only_numbers:`Only numbers allowed`,
            pdfReportsIconTooltip: `Generate Report`,
            generateReport:`Generate Report`,
            cant_be_imported:`User cant be imported`,
            domain_not_allowed: `Domain is not allowed`,
            email: `Email`,
            password: `Password`,
            home: `Home`,
            login: `Login`,
            send: `send`,
            max_retries: `Max retries reached`,
            wrong_code: `Wrong code`,
            expired: `Expired`,
            user_already_exists: `User already exists`,
            success: `Success`,
            not_found: `Item Not found`,
            all_fields_required: `All fields required`,
            item_name_missing: `An item name is missing`,
            userSettings:`User Settings`,
            mySpace: `My Data`,
            notifications: `Notifications`,
            progress: `Progress`,
            reports: `Reports`,
            report: `Report`,
            managment: `Management`,
            employees: `Import Employees`,
            employeesSub: `Employee Management`,
            settings: `Settings`,
            logout: `Log out`,
            search:`Search`,
            totalProgress:`Total Progress`,
            status: `Status`,
            change: `Edit`,
            editIconTooltip: `Edit`,
            deleteIconTooltip: `Delete`,
            cancelBtn: `cancel`,
            addBtn: `add`,
            updateBtn: `Update`,
            add: `Add`,
            update: `Update`,
            delete: `Delete`,
            deleteMessage: `Are you sure you want to remove this item and all related items?`,
            required: `Required`,
            upload: `Upload`,
            confidential: `Confidential`,
            normal: `Normal`,
            date: `Date`,
            new: `New`,
            usersSettings: `User Role Settings`,
            updateUser: `Update User`,
            platformSettings: `Platform Settings`,
            thresholdSettings: `Threshold Settings`,
            name: `Name`,
            percentageWord: `Percentage`,
            saveSetting: `Save Settings`,
            slug: `Slug (no space)`,
            arabic: `Arabic`,
            english: `English`,
            phoneNumber: `Phone`,
            importUser: `Import User & Open an account`,
            employeeData: `Employee Data`,
            employee: `Employee`,
            accept: `Accept`,
            type: `Type`,
            reject: `Reject`,
            rejectMessage: `Rejection Note`,
            pending:`Pending`,
            approved: `Approved`,
            dones: `Done`,
            todos: `To Dos`,
            supports: `Support`,
            comments: `Comments`,
            reportName: `Report Name`,
            fromDate: `From Date`,
            toDate: `To Date`,
            by: `by`,
            submitReport: `Submit Report`,
            deleteReport: `Delete Report`,
            updateReport: `Update Report`,
            myReports: `My Reports`,
            all: `All`,
            totals: `Totals`,
            lastSeen: `Last Update`,
            user_does_not_exist: `User does not exist`,
            viewIconTooltip: `View details`,
            reportsIconTooltip: `View Reports`,
            closeBtn: `Close`,
            SMSCode: `SMS Code`,
          ////////////////
      },
      ar: {
        categories: "الفئات",
        re_password:`كرر ادخال كلمة السر`,
        reset_email_sent:`تم الارسال الى بريدك الخاص`,
        password_no_match:`كلمات السر لا تتطابق`,
        phone_required:`رقم الهاتف مطلوب`,
        acceptTOC:`اوافق على الشروط والاحكام`,
        certificates_sub:`طباعة الشهادات`,
        print_certificate_pdf:`طباعة الشهادة`,
        certificates:`الشهادات المعتمدة`,
        no_user_finished:`لم يكمل اي مستخدم التقييم`,
        comp_final_report:`تقرير نهائي شامل`,
        final_report:`التقرير النهائي`,
        /////////////////// BAYAA
        dashboard:`الرئيسية`,
        assessment:`التقييم`,
        result:`النتيجة`,
        close_menu:`اغلاق القائمة`,
        its:`نظام التفكير المبتكر`,
        intro_subtitle:`تقييم وخرائط للمؤسسات والافراد. تقديم نهج منظم لربط الأفكار الإبداعية بالتنفيذ الناجح.`,
        no_notifications:`لا يوجد اشعارات`,
        features_title: `يمكنك تسريع الابتكار في:`,
        benefit_one: `المنتجات الجديدة، التقنيات، تطوير الخدمات`,
        benefit_two: `نماذج الأعمال المستقبلية، الاستراتيجيات، الخطط، تطوير القيم الجديدة`,
        benefit_three: `توليد الأفكار، قيادة المشاريع، إشراك أصحاب المصلحة`,
        benefit_four: `استراتيجيات التسويق الجديدة، الكفاءة التشغيلية في المنظمات`,
        features_footer: `اكتشف طرق جديدة للتفكير`,
        footer_intro: `احدث التقنيات والذكاء الاصطناعي للوصول لنتائج مخصصة بشكل كامل للأفراد والمؤسسات لمساعدتهم في اكتشاف طرق جديدة للتفكير وفعل الأشياء.`,
        copyright_reserved: `جميع الحقوق محفوظة لشركة`,
        contact_us_through_email: `تواصل معنا من خلال البريد الإلكتروني:`,
        toc:`الشروط والأحكام`,
        instructions_title: `التعليمات الخاصة بالتقييم`,
        instructions_subtitle: `يرجى الاطلاع بشكل دقيق على التعليمات التالية`,
        time_is_open: `الوقت لهذا التقييم مفتوح`,
        assessment_instruction_intro: `يتم الاجابة على الاسئلة في هذا التقييم عبر اختيار احد الخيارات التالية:`,
        to_almost_no_extent: `لا تقريبا`,
        to_a_slight_extent: `إلى حد ما`,
        to_a_moderate_extent: `إلى حد معتدل`,
        to_great_extent: `إلى حد كبير`,
        to_very_great_extent: `إلى حد كبير جدا`,
        assessment_done_check_result: `تم الانتهاء من التقييم يمكنك الاطلاع على النتيجة`,
        agree_to_instructions: `لقد اطلعت على التعليمات وانا جاهز لخوض التقييم`,
        start_assessment: `ابدأ التقييم الان`,
        assessment_result: `نتيجة التقييم`,
        all_users: `جميع المستخدمين`,
        manage_platform_users: `ادارة مستخدمين المنصة`,
        businesses: `المؤسسات`,
        users_count: `عدد المستخدمين`,
        users_started: `عدد من بدأ التقييم`,
        users_finished: `عدد من انهى التقييم`,
        user_users: `مستخدم/مستخدمين`,
        left_tokens: `يتبقى لديك`,
        add_user: `اضافة مستخدم`,
        business:`المؤسسة`,
        empoyee_name: `اسم الموظف`,
        verified_email: `بداية التقييم`,
        finished_assessment: `الانتهاء من التقييم`,
        print_pdf: `طباعة التقرير`,
        update: `تحديث`,
        assessment_progress: `التقدم في التقييم`,
        building_next_question: `تكوين السؤال التالي`,
        next: `التالي`,
        end_and_show_results: `انهاء التقييم وعرض النتائج`,
        creativity_problem: 'الابداع وحل المشاكل',
        risk_taking: 'المخاطرة',
        com_relation: 'التواصل والعلاقات',
        excution_managment: 'التطبيق والادارة',
        INVALID_PASSWORD: 'كلمة السر غير صحيحة',
        user_not_found: `المستخدم غير معرف`,
        assessment_result: `نتيجة التقييم`,
        assessment_result_map: `نتيجة التقيم وخريطة الابتكار الخاصة`,
        final_result: `النتيجة النهائية`,
        point: `نقطة`,
        detailed_report: `تقرير تفصيلي جاهز للطباعة`,
        stop_finish_later:`يمكن التوقف عند سؤال معين، والعودة لاكمال التقييم من حيث توقفت`,
        use_pc_or_phone: `يمكن اجراء التقييم من الكمبيوتر او من الهاتف`,
        its_pub_intro:`الذكاء الاصطناعي لرسم خريطة الابتكار للأفراد والمؤسسات`,
        //////////////////
        catalog:`منتجاتك`,
        shipping:`الشحن`,
        tickets:`الدعم`,
        wallet:`المحفظة`,
        account:`حسابي`,
        store:`متجرك`,
        accounts:`الحسابات`,
        requests:`طلبات السحب`,
        leadsMaster:`كل الطلبات`,
        //////
        item_name: 'اسم المنتج',
        price: 'السعر',
        quantity: 'الكمية',
        order_total: 'المجموع النهائي',
        your_details: 'التفاصيل',
        item_total: 'المجموع',
        continue_shopping: 'مواصلة التسوق',
        submit_order: 'إنهاء عملية الشراء',
        cart: 'سلة المشتريات',
        order_now: 'أطلبه الان',
        finish_order: 'إنهاء الشراء',
        time_left: 'الوقت المتبقي',
        details: 'مواصفات المنتج',
        country_choose: 'الرجاء اختيار دولتك',
        items_in_order: 'المشتريات',
        name: 'الاسم',
        phone_number: 'رقم الهاتف',
        add_to_cart: 'اضف الى السلة',
        thank_you: `تم ارسال طلبك بنجاح`,
        tomorrow: `عد غدا مجددا لزيارتنا لاخر عروضنا`,
        deliveryJO: `3 دنانير أجور توصيل`,
        deliverySA: `اضف منتج اخر لتحصل على فينيير مجانا`,
        deliveryJOS: `لقد حصلت على توصيل مجاني لطلبك`,
        deliverySAS: `لقد حصلت على فينيير مجاني`,
        delivery_total:`اجور التوصيل`,
        delivery_free: `لقد حصلت على توصيل مجاني لطلبك`,
        sold: `مباع `,
        piece: ` قطعة`,
        added_to_cart: `تم الاضافة الى السلة`,
        size_color:`الحجم/اللون`,
        cancel:`اغلاق`,
        total: 'المجموع',
        lowestJO:`اقل اسعار في الاردن`,
        lowestSA:`اقل اسعار في السعودية`,
        dismiss:`اغلاق`,
        search:`بحث`,
        back:`الرئيسية`,
        tax:`شامل الضريبة`,

        //// nav
        start:`ابدأ الان`,
        emailSoftware:`الايميلات`,
        campaigns:`الحملات`,
        campaign:`حملة`,
        lists:`القوائم`,
        list:`قائمة`,
        templates:`القوالب`,
        template:`قالب`,
        accountCreated:`تم انشاء الحساب`,
        sent:`ارسال`,
        opened:`فتح`,
        clicked:`نقر`,
        lastChange:`اخر تحديث`,
        agent:`الموظف`,
        access:`الدخول`,
        userRole: `نوع المستخدم`,
        users: `مستخدمين`,
        user: `المستخدم العادي`,
        admin: `مدير`,
        superadmin: `مدير عام`,
        userEmail: `ايميل المستخدم`,
        userName: `اسم المستخدم`,
        close: `اغلاق`,
        position: `المسمى الوظيفي`,
        submitBtn: `تخزين`,
        reload: `اعادة تحميل`,
        subject: `العنوان`,
        fromName: `اسم المرسل`,
        fromEmail: `ايميل المرسل`,
        replyTo: `الردود الى`,
        lastUpdated: `اخر تحديث`,
        sendingActive: `جاري الارسال...`,
        inDraft: `مسودة`,
        alreadySent: `تم ارسال`,
        sendIconTooltip: `ارسال الان`,
        scheduleIconTooltip: `الارسال لاحقاً`,
        valid_email: `يرجى ادخال ايميل صحيح`,
        leads: `الطلبات`,
        subscribers: `ايميلات الملتحقين`,
        suppression: `منع الارسال`,
        offices: `المكاتب`,
        loginWithGoogle: `الدخول باستخدام Google`,
        register: `تسجيل`,
        forgetPassword: `نسيت كلمة السر؟`,
        sendResetEmail:`ارسال ايميل لاستعادة كلمة السر`,
        please_use_google_to_login: `يرجى استخدام Google لتسجيل الدخول`,
        user_not_found: `الحساب غير موجود`,
        listings: `العروض`,
        applicationsCenter: `مركز الطلبات`,
        cv: `السيرة الذاتية`,
        cvs: `السير الذاتية`,
        resume: `السيرة الذاتية`,
        resumes: `السير الذاتية`,
        coverletters: `الرسائل`,
        appsettings: `الاعدادات`,
        applications: `الطلبات`,
        inbox: `البريد`,
        corporate: `المؤسسة`,
        billing: `الفواتير`,
        receipts: `المدفوعات`,
        plan: `الخطة`,
        upgradePlan: `ترقية`,
        addToShortList: `اضافة الى المفضلة`,
        shortlists: `المفضلة`,
        note: `ملاحظة`,
        from: `من`,
        to: `الى`,
        latest: `الاحدث`,
        specialty: `الاختصاص`,
        city: `المدينة`,
        state: `الولاية`,
        verified: `تم التحقق منه`,
        prefer: `يفضل الايميل`,
        limit: `الحد الاعلى`,
        description: `وصف`,
        "cover-letters": `الرسائل`,




        /////////////
        captcha:`الرجاء ادخال الرمز الموجود في الصورة`,
        wrong_captcha: `لقد قمت بادخال رمز خطا`,
        only_numbers: `يسمح بأدخال الارقام فقط`,
        progressTitle: `التقدم`,
        pdfReportsIconTooltip: `انشاء تقرير`,
        generateReport: `انشاء تقرير`,
        clearChart: `اعادة تعيين`,
        cant_be_imported: `لا يمكن استيراد هذا الموظف`,
        domain_not_allowed: `هذا النطاق غير مسموح به`,
        allLegend: `مفتاح العتبات`,
        specialAccess: `اعطاء المستخدم صلاحيات لعرض صفحات الوزارة`,
        email: `الايميل`,
        password: `كلمة السر`,
        login: `تسجيل الدخول`,
        send: `ارسال`,
        home: `الرئيسية`,
        max_retries: `تخطيت عدد المحاولات المسموحة`,
        wrong_code: `خطأ في كتابة الرمز، يرجى المحاولة مرة اخرى`,
        expired: `انهت صلاحية الجلسة`,
        user_already_exists: `تم استيراد هذا المستخدم سابقاً`,
        success: `تمت العملية بنجاح`,
        not_found: `العنصر غير موجود`,
        all_fields_required: `جميع الحقول مطلوبة`,
        item_name_missing: `احد العناصر ينقصه اسم`,
        organisation: `نظرة عامة على الوزارة`,
        strategy: `استراتيجية الوزارة`,
        orgProgress: `مقياس انجاز الوزارة`,
        orgStructure: `الهيكل التنظيمي للوزارة`,
        userSettings: `اعدادات المستخدم`,
        mySpace: `المساحة الشخصية`,
        notifications: `الاشعارات`,
        progress: `الاهداف والمنجزات`,
        reports: `التقارير`,
        report: `تقرير`,
        managment: `لوحة التحكم`,
        employees: `استيراد الموظفين`,
        employeesSub: `ادارة الموظفين`,
        charts: `الرسم البياني للأداء`,
        approvals: `موافقاتي`,
        user: `حسابي`,
        orgStructureSetting: `تعديل الهيكل التنظيمي`,
        settings: `الاعدادات`,
        pubReports: `اصدار تقرير`,
        logout: `الخروج`,
        ////// progress
        search: `ابحث`,
        totalProgress:`اجمالي الانجازات`,
        goals:`الاهداف`,
        goal: `هدف`,
        keyResult:`نتيجة رئيسية`,
        keyResults:`نتائج رئيسية`,
        initiative:`مبادرة`,
        initiatives:`مبادرات`,
        trend: `التباين`,
        progress: `الاهداف والمنجزات الرئيسة`,
        mainResult: `النتائج/المبادرات`,
        status: `الحالة`,
        change: `تعديل`,
        editIconTooltip: `تعديل`,
        deleteIconTooltip: `مسح`,
        trending: {
          up:`تقدم`,
          down:`تراجع`,
          flat:`ثبات`
        },
        addGoal: `اضافة هدف`,
        addGoalTitle: `اضافة هدف`,
        editGoalTitle: `تعديل هدف`,
        parentGoal: `هدف علوي يرتبط به`,
        deleteGoalTitle: `مسح هدف`,
        addKeyResult: `اضافة نتيجة`,
        addKeyResultTitle: `اضافة نتيجة`,
        editKeyResultTitle: `تعديل نتيجة`,
        deleteKeyResultTitle: `مسح نتيجة`,
        addInit: `اضافة مبادرة`,
        addInitTitle: `اضافة مبادرة`,
        editInitTitle: `تعديل مبادرة`,
        deleteInitTitle: `مسح مبادرة`,
        viewGoalTitle: `تفاصيل الهدف`,
        viewKeyResultTitle: `تفاصيل النتيجة الرئيسية`,
        viewInitTitle: `تفاصيل المبادرة`,
        cancelBtn: `الغاء`,
        addBtn: `اضافة`,
        updateBtn: `تحديث`,
        add:`اضافة`,
        update:`تعديل`,
        delete:`مسح`,
        deleteMessage:`هل انت متأكد من ازالة هذا العنصر وكل ما يتعلق به بشكل نهائي؟`,
        startValue: `قيمة البداية`,
        targetValue: `قيمة الهدف`,
        unite: `وحدة القياس`,
        currentValue: `القيمة الحالية`,
        weight:`قيمة المساهمة`,
        quarter:`الربع`,
        meters: `متر`,
        dollar: `دولار امريكي`,
        riyal: `ريال سعودي`,
        rank: `ترتيب`,
        number: `عدد`,
        mbps: `Mbps`,
        gbps: `Gbps`,
        percentage:`%`,
        quarter_one: `الربع الاول`,
        quarter_two: `الربع الثاني`,
        quarter_three: `الربع الثالث`,
        quarter_four: `الربع الرابع`,
        required: `مطلوب`,
        upload: `تحميل ملف`,
        confidential: `سري`,
        normal: `عادي`,
        fileType: `نوع الملف`,
        files:`ملفات`,
        date: `التاريخ`,
        new: `جديد`,
        theVision: `الرؤية`,
        theMission: `المهمة`,
        theMessage: `الرسالة`,
        usersSettings: `اعدادات انواع المستخدمين`,
        updateUser: `تحديث المستخدم`,
        platformSettings: `اعدادات النظام`,
        thresholdSettings: `اعدادات العتبات`,
        uniteSettings: `اعدادات وحدات القياس`,
        fileTypeSettings: `اعدادات تصنيف سرية المستندات الداعمة`,
        allowedFilesSettings: `اعدادات انواع الملفات المسموحة`,
        AddThreshold:`اضافة عتبة`,
        name: `الاسم`,
        percentageWord: `النسبة`,
        saveSetting: `تخزين الاعدادات`,
        slug: `اسم التخزين (دون فراغ)`,
        arabic: `العربية`,
        english: `الانجليزية`,
        AddUnite: `اضافة وحدة`,
        hundredError: `يجب ان يكون اقل من 100`,
        AddFileType: `اضافة تصنيف`,


        addMainLevel: `اضافة منصب اساسي`,
        addBelow: `اضافة منصب فرعي`,
        phoneNumber: `رقم الهاتف`,
        importUser: `استيراد المستخدم وانشاء حساب`,
        employeeData: `معلومات الموظف`,
        employee: `الموظف`,
        accept: `موافقة`,
        type:`النوع`,
        reject: `رفض`,
        rejectMessage: `ملاحظة الرفض`,
        acceptedNotification: `تم الموافقة على`,
        rejectNotification: `تم رفض`,
        submissionNotification: `بحاجة للمراجعة`,
        deletionNotification: `تم مسح`,
        pending: `بانتظار المراجعة`,
        approved: `حصل على الموافقة`,
        there:`هناك`,
        createNewReport: `انشاء تقرير جديد`,
        dones: `انجازات`,
        todos: `خطط`,
        supports: `بحاجة دعم`,
        comments: `تعليقات`,
        reportName: `اسم التقرير`,
        fromDate: `من تاريخ`,
        toDate: `الى تاريخ`,
        newReportNotification: `تقرير جديد بعنوان`,
        by: `بواسطة`,
        submitReport: `تقديم التقرير`,
        deleteReport: `مسح التقرير`,
        updateReport: `تحديث التقرير`,
        uniteThresholds: `توحيد الاعدادات لجميع الفئات من المنجزات`,
        myReports: `تقاريري`,
        employeesReports: `تقارير الموظفين`,
        all: `الكل`,
        totals: `اجمالي الانجازات`,
        stepName: `اسم العتبة`,
        stepSettings: `اعدادات العتبة`,
        instituteSettings: `تعديل استراتيجية الوزارة`,
        lastSeen: `اخر تحديث`,
        getEmailNotifications: `الحصول على تنبيهات الأهداف و المنجزات و المبادرات عبر الايميل`,
        getReportsByEmail: `الحصول على تنبيهات التقارير عبر الايميل`,
        user_does_not_exist: `هذا المستخدم غير موجود`,
        viewIconTooltip: `الاطلاع على التفاصيل`,
        reportsIconTooltip: `الاطلاع على التقارير`,
        closeBtn: `اغلاق`,
        SMSCode: `الرمز المرسل في الرسالة النصية`,

      },
    },
    modelMenu: [
      {icon:'space_dashboard', text:'dashboard', path:'/dashboard', roles:['master','superadmin', 'admin', 'user']},
      {icon:'check_circle', text:'notifications', path:'/notifications', roles:['master','superadmin', 'admin', 'user']},
      {icon:'business', text:'leads', path:'/leads', roles:['master','superadmin', 'admin', 'user']},
      {icon:'assignment', text:'grandCategories', path:'/grand-categories', roles:['master','superadmin', 'admin', 'user']},
      {icon:'assignment', text:'categories', path:'/categories', roles:['master','superadmin', 'admin', 'user']},
      {
        icon: 'apps',
        text: 'megatracker',
        path: '/application',
        sub:true,
        roles:['master', 'superadmin', 'user'],
        subs:[
          {icon:'language', text:'trackerdomains', path:'/tracker-domains', roles:['master', 'superadmin', 'admin', 'user'], sub:true, folder:'megatracker'},
          {icon:'schema', text:'trackerPixels', path:'/tracker-pixels', roles:['master', 'superadmin', 'admin', 'user'], sub:true, folder:'megatracker'},
          {icon:'analytics', text:'trakers', path:'/trackers', roles:['master', 'superadmin', 'admin', 'user'], sub:true, folder:'megatracker'},
          {icon:'mouse', text:'actions', path:'/actions', roles:['master', 'superadmin'], sub:true, folder:'megatracker'},
          {icon:'track_changes', text:'events', path:'/events', roles:['master', 'superadmin'], sub:true, folder:'megatracker'},
          {icon:'work', text:'platforms', path:'/platforms', roles:['master', 'superadmin'], sub:true, folder:'megatracker'},
        ]
      },
      {
        icon: 'apps',
        text: 'snapp',
        path: '/application',
        sub:true,
        roles:['master', 'superadmin', 'user'],
        subs:[
          {icon:'fingerprint', text:'brands', path:'/brands', roles:['master', 'superadmin', 'admin', 'user'], sub:true, folder:'snapp'},
          {icon:'call_to_action', text:'ctas', path:'/ctas', roles:['master', 'superadmin', 'admin', 'user'], sub:true, folder:'snapp'},
          {icon:'link', text:'links', path:'/links', roles:['master', 'superadmin', 'admin', 'user'], sub:true, folder:'snapp'},
          // {icon:'folder_shared', text:'leads', path:'/leads', roles:['master', 'superadmin', 'admin', 'user'], sub:true, folder:'snapp'},
        ]
      },
      {
        icon: 'business',
        text: 'adminstrator',
        path: '/account',
        roles:['master'],
        subs:[
          {icon:'supervised_user_circle', text:'accounts', path:'/accounts', roles:['master']},
        ]
      },
      {
        icon: 'settings',
        text: 'settings',
        path: '/settings',
        roles:['master', 'superadmin'],
        subs:[
          {icon:'manage_accounts', text:'account', path:'/account', roles:['master', 'superadmin', 'admin', 'user']},
          {icon:'people', text:'users', path:'/users', roles:['master', 'superadmin']},
          {icon:'receipt', text:'billing', path:'/billing', roles:['master', 'superadmin', 'admin', 'user']},
          {icon:'settings', text:'services', path:'/services', roles:['master', 'superadmin', 'admin', 'user']},
          {icon:'money', text:'plans', path:'/plans', roles:['master', 'superadmin', 'admin', 'user']},

        ]
      },
      {
        icon: 'support',
        text: 'support',
        path: '/support',
        roles:['master', 'superadmin', 'admin', 'user'],
        subs:[
          {icon:'school', text:'knowledge', path:'/knowledge', roles:['master', 'superadmin', 'admin', 'user']},
          {icon:'help', text:'tickets', path:'/tickets', roles:['master', 'superadmin', 'admin', 'user']},
        ]
      },

    ],
    resourceSettings:{
      brands: {
        resourceName:null,
        search:true,
        create:true,
        pagination:true,
        path:'',
        dialog:'default',
        icon:'fingerprint',
        title:'Brands',
        sub_title:'Manage account brands',
        steps:false,
      },
      ctas: {
        resourceName:null,
        search:true,
        create:true,
        pagination:true,
        path:'',
        dialog:'ctas',
        icon:'call_to_action',
        title:'Calls to Action',
        sub_title:'Manage account Calls to Action',
        steps:[
          {title:'Basic Setup'},
          {title:'Content'},
          {title:'Design'},
          {title:'Design'},
        ],
      },
      services:{
        resourceName: null,
        search: false,
        create: false,
        pagination: true,
      },
      plans:{
        resourceName: null,
        search: false,
        create: false,
        pagination: true,

      },
      "tracker-domains":{
        resourceName: 'domains',
        search: true,
        create: true,
        pagination: true,
        icon:'language',
        title:'Domains',
        sub_title:'Manage your domains here',
      },
      "tracker-pixels":{
        resourceName: 'pixels',
        search: true,
        create: true,
        pagination: true,
        icon:'schema',
        title:'Pixels',
        sub_title:'Manage your pixels here',
      },
      trackers:{
        resourceName: 'trackers',
        search: true,
        create: true,
        pagination: true,
        icon:'analytics',
        title:'Trackers',
        sub_title:'Manage your trackers here',
      },
      actions:{
        resourceName: 'trackers',
        search: true,
        create: true,
        pagination: true,
        icon:'mouse',
        title:'Actions',
        sub_title:'Manage Actions',
      },
      events:{
        resourceName: 'trackers',
        search: true,
        create: true,
        pagination: true,
        icon:'track_changes',
        title:'Events',
        sub_title:'Manage Events',
      },
      platforms:{
        resourceName: 'trackers',
        search: true,
        create: true,
        pagination: true,
        icon:'work',
        title:'Platforms',
        sub_title:'Manage Platforms',
      },
    },
    resourceKeys:{
      actions: [
        { name: 'slug', label:'slug', type:'text', required: true },
        { name: 'label', label:'label', type:'text', required: true },
        { name: 'description', label:'description', type:'text', required: true },
        { name: 'active', label:'active', type:'switch', required: true },
      ],
      events: [
        { name: 'platform_id', label:'platform', type:'select', data:[], items:'platforms', source:'db', required: true },
        { name: 'slug', label:'slug', type:'text', required: true },
        { name: 'label', label:'label', type:'text', required: true },
        { name: 'description', label:'description', type:'text', required: true },
        { name: 'active', label:'active', type:'switch', required: true },
      ],
      platforms: [
        { name: 'slug', label:'slug', type:'text', required: true },
        { name: 'label', label:'label', type:'text', required: true },
        { name: 'active', label:'active', type:'switch', required: true },
      ],
      "tracker-domains": [
        { name: 'domain', label:'domain', type:'text', required: true },
        { name: 'active', label:'active', type:'switch', required: true },
      ],
      "tracker-pixels": [
        { name: 'pixel', label:'pixel', type:'text', required: true },
        { name: 'platform_id', label:'platform', type:'select', data:[], items:'platforms', source:'db', required: true },
      ],
      trackers: [
        { name: 'name', label:'name', type:'text', required: true },
        { name: 'selector', label:'selector', type:'text', required: true },
        { name: 'domain_id', label:'domain', type:'select', data:[], items:'domains', source:'db', required: true },
        { name: 'action_id', label:'action', type:'select', data:[], items:'actions', source:'db', required: true },
        { name: 'event_id', label:'event', type:'select', data:[], items:'events', source:'db', required: true },
        { name: 'platform_id', label:'platform', type:'select', data:[], items:'platforms', source:'db', required: true },
        { name: 'pixel_id', label:'pixel', type:'select', data:[], items:'pixels', source:'db', required: true },
        { name: 'active', label:'active', type:'switch', required: true },
      ],
      brands:[
        { name: 'name', label:'name', type:'text', required: true },
        { name: 'website', label:'website', type:'text', required: true },
        { name: 'logo', label:'logo', type:'upload' },
      ],
      ctas:[
        { name: 'brand_id', label:'brand', type:'select', items:'brands', source:'db', step:0, data:[] },
        { name: 'type', label:'type', type:'select', source:'local', step:0, required: true, data:[
          {text: 'Text', id:'text'},
          {text: 'Text with Body', id:'text_body'},
          {text: 'Button', id:'button'},
          {text: 'Text with Button', id:'text_button'},
          {text: 'Link', id:'link'},
          {text: 'Text with Link', id:'text_link'},
          {text: 'Form', id:'form'},
          {text: 'Text with Form', id:'text_form'},
          {text: 'Youtube Video', id:'youtube_video'},
          {text: 'Text with Youtube Video', id:'text_youtube_video'},
          {text: 'Vimeo Video', id:'vimeo_video'},
          {text: 'Text with Vimeo Video', slug:'text_vimeo_video'},
          {text: 'Image', id:'image'},
          {text: 'Text with Image', id:'text_image'},
        ] },

        { name: 'name', label:'name', type:'text', step:0, required: true },

        { name: 'title', label:'title', type:'text', step:1, types:[
          'text',
          'text_body',
          'text_button',
          'text_link',
          'text_form',
          'text_youtube_video',
          'text_vimeo_video',
          'text_image',
        ] },
        { name: 'sub_title', label:'sub_title', type:'text', step:1, types:[
          'text',
          'text_body',
          'text_button',
          'text_link',
          'text_form',
          'text_youtube_video',
          'text_vimeo_video',
          'text_image',
        ] },
        { name: 'body', label:'body', type:'textarea', step:1, types:[
          'text_body',
        ] },

        { name: 'button_text', label:'button_text', type:'text', step:1, types:[
          'button',
          'text_button',
        ] },
        { name: 'button_target', label:'button_target', type:'text', step:1, types:[
          'button',
          'text_button',
        ] },

        { name: 'email_label', label:'email_label', type:'text', step:1, types:[
          'form',
          'text_form',
        ] },
        { name: 'phone_label', label:'phone_label', type:'text', step:1, types:[
          'form',
          'text_form',
        ] },
        { name: 'name_label', label:'name_label', type:'text', step:1, types:[
          'form',
          'text_form',
        ] },

        { name: 'link_text', label:'link_text', type:'text', step:1, types:[
          'link',
          'text_link',
        ] },
        { name: 'link_url', label:'link_url', type:'text', step:1, types:[
          'link',
          'text_link',
        ] },

        { name: 'image_url', label:'image_url', type:'text', step:1, types:[
          'image',
          'text_image',
        ] },
        { name: 'youtube_url', label:'youtube_url', type:'text', step:2, types:[
          'youtube_video',
          'text_youtube_video',
        ] },
        { name: 'vimeo_url', label:'vimeo_url', type:'text', step:1, types:[
          'vimeo_video',
          'text_vimeo_video',
        ] },

        { name: 'email_validation', label:'email_validation', type:'switch', step:1, types:[
          'form',
          'text_form',
        ] },
        { name: 'name_validation', label:'name_validation', type:'switch', step:1, types:[
          'form',
          'text_form',
        ] },
        { name: 'phone_validation', label:'phone_validation', type:'switch', step:1, types:[
          'form',
          'text_form',
        ] },

        { name: 'position', label:'position', type:'select', source:'local', data:[
          {text: 'Top Left', id:'top_left'},
          {text: 'Top Right', id:'top_right'},
          {text: 'Bottom Left', id:'bottom_left'},
          {text: 'Bottom Right', id:'bottom_right'},
          {text: 'Center', id:'center'},
        ], step:2, required: true },
        { name: 'outer_padding', label:'outer_padding', type:'text', step:2 },
        { name: 'button_size', label:'button_size', type:'select', source:'local', step:2, data:[
          {text: 'X Large', id:'x-large'},
          {text: 'Large', id:'large'},
          {text: 'Normal', id:'normal'},
          {text: 'Small', id:'small'},
          {text: 'X Small', id:'x-small'},

        ], types:[
          'button',
          'text_button',
        ] },
        { name: 'field_type', label:'field_type', type:'select', source:'local', step:2, data:[
          {text: 'Line Style', id:'line'},
          {text: 'Raised', id:'solo'},
          {text: 'Outlined', id:'outlined'},
          {text: 'Filled', id:'filled'},
        ], types:[
          'form',
          'text_form',
        ] },
        { name: 'right_to_left', label:'right_to_left', type:'switch', step:3 },

        { name: 'background_color', label:'background_color', type:'text', step:3 },
        { name: 'text_color', label:'text_color', type:'text', step:3, types:[
          'text',
          'text_body',
          'text_button',
          'text_link',
          'text_form',
          'text_youtube_video',
          'text_vimeo_video',
          'text_image',
        ] },
        { name: 'link_color', label:'link_color', type:'text', step:3, types:[
          'link',
          'text_link',
        ] },
        { name: 'field_color', label:'field_color', type:'text', step:3, types:[
          'form',
          'text_form',
        ] },
        { name: 'field_text_color', label:'field_text_color', type:'text', step:3, types:[
          'form',
          'text_form',
        ] },
        { name: 'label_color', label:'label_color', type:'text', step:3, types:[
          'form',
          'text_form',
        ] },
        { name: 'button_color', label:'button_color', type:'text', step:3, types:[
          'button',
          'text_button',
        ] },
        { name: 'button_text_color', label:'button_text_color', type:'text', step:3, types:[
          'button',
          'text_button',
        ] },
      ],
      services:[
        { name: 'name', label:'name', type:'text', required: true },
        { name: 'label', label:'label', type:'text', required: true },
      ],
      plans:[
        { name: 'service_id', label:'service', type:'select', data:[], items:'services', source:'db', required: true },
        { name: 'name', label:'name', type:'text', required: true },
        { name: 'label', label:'label', type:'text', required: true },
        { name: 'price', label:'price', type:'number', required: true },
        { name: 'duration', label:'duration', type:'number', required: true },
        { name: 'users', label:'users', type:'number', required: true },
        { name: 'active', label:'active', type:'switch', required: true },
        { name: 'public', label:'public', type:'switch', required: true },

      ]
    },
    menu:[],
    access_token: null,
    verification:false,
    online:false,
    centralLogin:false,
    globalLoading:false,
    user: null,
    users:[],
    uid:null,
    language:'en',
    notifications:[],
    settings: {
      baseUrl: ``,
      apiBase: ``,
      public: ``,
    },
    userRoles:[
      {slug:'master', text:'Master'},
      {slug:'superadmin', text:'Superadmin'},
      {slug:'admin', text:'Admin'},
      {slug:'user', text:'User'},
    ],
    loading: false,
    selectedAccount:{},
  },
  modules: {
  },
  getters: {

  },
  mutations: {
    unAuthLogout(state) {
      state.access_token = null
      state.user = null
      state.uid = null
      state.centralLogin = false
      state.menu = []
      state.globalLoading = []
      state.users = []
      state.notifications = []
      let noGate = ['home', 'login', 'register', 'toc', 'verify']
      // console.log(router.currentRoute.name)
      if(!noGate.includes(router.currentRoute.name)) {
        router.push('/home').catch(x => {})
      }
    },
    setOnline(state, payload) {
      state.online = payload == 1 ? true : false
    },
    updateNotifications(state, payload) {
      // let newNotifications = payload.filter(x=>!state.notifications.map(x=>x.id).includes(x.id))
      state.notifications = payload// [...newNotifications, ...state.notifications]
    },
    setBaseUrl(state, payload) {
      state.settings.baseUrl = `${payload.base}`
      state.settings.apiBase = `${payload.base}/api/v1`
      // state.settings.apiBase = `${payload.base}/b/public/api/v1`
      state.settings.public = `${payload.base}/b/storage/app/`
    },
    setUser(state, payload){
      state.user = payload
    },
    setAccount(state, payload){
      if(localStorage.account) {
        state.selectedAccount = JSON.parse(localStorage.account)
      } else {
        localStorage.account = JSON.stringify(payload.accounts[0])
        state.selectedAccount = payload.accounts[0]
      }
    },
    loadLanguage(state) {
      return new Promise(async(res, rej)=>{
        if(localStorage.language) {
          state.language = localStorage.language
          if(state.language == 'ar') {
            Vue.prototype.$vuetify.rtl = true
          } else {
            Vue.prototype.$vuetify.rtl = false
          }
        } else {
            let language = 'ar'
            state.language = language
            localStorage.language = language
            if(language == 'ar') {
              Vue.prototype.$vuetify.rtl = true
            } else {
              Vue.prototype.$vuetify.rtl = false
            }
        }
        res(true)
      })
    },
  },
  actions: {
    setSettingsBase({ commit, dispatch, state }, payload){
      return new Promise(async (resolve, reject) => {
        commit('setBaseUrl', payload)
        resolve(true)
      })
    },
    getUser({ commit, dispatch, state }) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`
        axios.interceptors.request.use(function (config) {
          let token = state.access_token
          if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
          }
          return config;
        }, function (error) {
          return Promise.reject(error);
        })
        axios.interceptors.response.use(async response => {
          return response;
        }, async error => {
          if (error.response.status === 401) {
            commit('unAuthLogout')
          }
          return error;
        });
        let a = await axios.get(`${state.settings.apiBase}/user/me`)
          .then(x => x.data).catch(error=>{})
        // console.log(a)
        await commit('setUser', a)
        await commit('setAccount', a)
        resolve(a)
      })
    },
    checkAuth({ commit, dispatch, state }) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`
        axios.interceptors.request.use(function (config) {
          let token = state.access_token
          if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
          }
          return config;
        }, function (error) {
          commit('unAuthLogout')
        })
        axios.interceptors.response.use(async response => {
          return response;
        }, async error => {
          if (error.response.status === 401) {
            commit('unAuthLogout')
          }
          return error;
        });
        let a = await axios.get(`${state.settings.apiBase}/user/check`)
          .then(x => x.data).catch(error=>{
            // console.log(error)
          })
        resolve(a)
      })
    },
    logout({ commit, dispatch, state }) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`
        axios.interceptors.request.use(function (config) {
          // assume your access token is stored in local storage
          // (it should really be somewhere more secure but I digress for simplicity)
          let token = state.access_token
          if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
          }
          return config;
        }, function (error) {
          // Do something with request error
          return Promise.reject(error);
        })
        try {
          let a = await axios.get(`${state.settings.apiBase}/user/logout`)
          .then(x => x.data)
          resolve(a)
        } catch (error) {
          resolve(false)
        }
      })
    },
    postResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`
        axios.interceptors.request.use(function (config) {
          let token = state.access_token
          if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
          }
          return config;
        }, function (error) {
          return Promise.reject(error);
        })
        axios.interceptors.response.use(async response => {
          return response;
        }, async error => {
          if (error.response.status === 401) {
            commit('unAuthLogout')
          }
          return error;
        });
        let a = await axios.post(`${state.settings.apiBase}${payload.resource}`, {...payload.value})
          .then(x => x.data).catch(error=>{})
          // console.log(a)
          resolve(a)
      })
    },
    getResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`
        axios.interceptors.request.use(function (config) {
          let token = state.access_token
          if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
          }
          return config;
        }, function (error) {
          return Promise.reject(error);
        })
        axios.interceptors.response.use(async response => {
          return response;
        }, async error => {
          if (error.response.status === 401) {
            commit('unAuthLogout')
          }
          return error;
        });
        let a = await axios.get(`${state.settings.apiBase}${payload.resource}${payload.page?payload.page:''}`)
          .then(x => x.data).catch(error=>{})
          // console.log(a)
          resolve(a)
      })
    },
    searchResource ({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`
        axios.interceptors.request.use(function (config) {
          let token = state.access_token
          if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
          }
          return config;
        }, function (error) {
          return Promise.reject(error);
        })
        axios.interceptors.response.use(async response => {
          return response;
        }, async error => {
          if (error.response.status === 401) {
            commit('unAuthLogout')
          }
          return error;
        });
        let a = await axios
        .post(`https://yervip.com/back/public/api/v1/ninjasearch/${state.country.alpha2Code}${payload.page?payload.page:''}`, {value:state.search})
        .then(x => x.data).catch(error=>{})
        router.push(`/search`).catch(x=>{});
        state.products = []
        let prod = await commit('loadProducts', a.data)
        state.search_resource = a
        resolve(a)
      })
    },
    putResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`
        axios.interceptors.request.use(function (config) {
          let token = state.access_token
          if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
          }
          return config;
        }, function (error) {
          return Promise.reject(error);
        })
        axios.interceptors.response.use(async response => {
          return response;
        }, async error => {
          if (error.response.status === 401) {
            commit('unAuthLogout')
          }
          return error;
        });
        let a = await axios.put(`${state.settings.apiBase}${payload.resource}`, {...payload.value})
          .then(x => x.data).catch(error=>{})
          // console.log(a)
          resolve(a)
      })
    },
    deleteResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`
        axios.interceptors.request.use(function (config) {
          let token = state.access_token
          if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
          }
          return config;
        }, function (error) {
          return Promise.reject(error);
        })
        axios.interceptors.response.use(async response => {
          return response;
        }, async error => {
          if (error.response.status === 401) {
            commit('unAuthLogout')
          }
          return error;
        });
        let a = await axios.delete(`${state.settings.apiBase}${payload.resource}`)
          .then(x => x.data).catch(error=>{})
          // console.log(a)
          resolve(a)
      })
    },
    getNotifications({ commit, dispatch, state }) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`
        axios.interceptors.request.use(function (config) {
          let token = state.access_token
          if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
          }
          return config;
        }, function (error) {
          return Promise.reject(error);
        })
        axios.interceptors.response.use(async response => {
          return response;
        }, async error => {
          if (error.response.status === 401) {
            commit('unAuthLogout')
          }
          return error;
        });
        let a = await axios.get(`${state.settings.apiBase}/notifications-mini`)
          .then(x => x.data).catch(error=>{})
        await commit('updateNotifications', a)

        resolve(a)
      })
    },
  },
});
